import { usePrevValue } from "./usePrevValue";

export const useValueChanged = <Value>(value: Value, skipNull = false) => {
  const prevValue = usePrevValue(value);

  return skipNull ? prevValue !== null && prevValue !== value : prevValue !== value;
};
